import Autocomplete, { Config } from "bootstrap5-autocomplete";
import $$ from "../utils/double-dollar";
import Multilang from "../utils/multilang";

class SearchAutoComplete {
  constructor(inputElement: HTMLInputElement) {
    let totalSuggestionCount = 0;

    function isHiddenMenuEl(menuEl: HTMLElement) {
      const style = window.getComputedStyle(menuEl);
      return (style.display === "none")
    }

    function getActiveMenuEl(): HTMLElement {
      const autocompleteMenuElDesktop = document.getElementById("ac-menu-1") as HTMLElement;
      const autocompleteMenuElMobile = document.getElementById("ac-menu-2") as HTMLElement;

      return autocompleteMenuElMobile && !isHiddenMenuEl(autocompleteMenuElMobile)
        ? autocompleteMenuElMobile
        : autocompleteMenuElDesktop;
    }

    function getActiveListItemEl(menuEl: HTMLElement): HTMLElement {
      return $(menuEl).find("li.autocomplete-menu-list-item--active")[0];
    }

    function toggleActiveListItemEl(increase: boolean, e: KeyboardEvent) {
      const menuEl = getActiveMenuEl();
      const activeListItemEl = getActiveListItemEl(menuEl);

      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        e.preventDefault();
      }

      if (activeListItemEl) {
        $(activeListItemEl).removeClass("autocomplete-menu-list-item--active");

        const activeListElCounter = Number.parseInt(activeListItemEl.id.replace("autocomplete-menu-list-item-", ""));
        const nextListElCounter = increase ? activeListElCounter + 1 : activeListElCounter - 1;
        const nextListEl = $(menuEl).find(`li#autocomplete-menu-list-item-${nextListElCounter}`);

        // when key is tab and active list item is not last, prevent default handling
        if (e.key === "Tab" && activeListElCounter < totalSuggestionCount) {
          e.preventDefault();
        }

        if (nextListEl) {
          nextListEl.addClass("autocomplete-menu-list-item--active");
        }
        else {
          $(menuEl).find("li").first().addClass("autocomplete-menu-list-item--active");
        }
      }
      else {
        // when key is tab and list is not empty, prevent default handling
        if (e.key === "Tab" && totalSuggestionCount > 0) {
          e.preventDefault();
        }

        $(menuEl).find("li").first().addClass("autocomplete-menu-list-item--active");
      }
    }

    function appendSearches(groupedItems: any, targetEl: HTMLElement) {
      const titleEl = document.createElement("h6");
      titleEl.innerText = Multilang.getTranslation("autocomplete.title.searches", "Zoeksuggesties")
      targetEl.appendChild(titleEl);

      const listEl = document.createElement("ul");

      for (const item of groupedItems["Searches"]) {
        const listItemEl = document.createElement("li");
        listItemEl.id = `autocomplete-menu-list-item-${item.counter}`;

        const listItemLinkEl = document.createElement("a");
        listItemLinkEl.innerText = item.label;
        listItemLinkEl.href = item.value;

        listItemLinkEl.addEventListener("pointerdown", (e) => {
          e.preventDefault();
          document.location.href = item.value;
        });

        listItemEl.appendChild(listItemLinkEl);
        listEl.appendChild(listItemEl);
      }

      targetEl.appendChild(listEl);
    }

    function appendCategories(groupedItems: any, targetEl: HTMLElement) {
      const titleEl = document.createElement("h6");
      titleEl.innerText = Multilang.getTranslation("autocomplete.title.categories", "Categorieën")
      targetEl.appendChild(titleEl);

      const listEl = document.createElement("ul");

      for (const item of groupedItems["Categories"]) {
        const listItemEl = document.createElement("li");
        listItemEl.id = `autocomplete-menu-list-item-${item.counter}`;

        const listItemImageEl = document.createElement("img");
        listItemImageEl.src = item.imageUri;
        listItemImageEl.alt = "";

        const listItemLinkEl = document.createElement("a");
        listItemLinkEl.innerHTML = `${listItemImageEl.outerHTML}&nbsp;<span>${item.label}</span>`;
        listItemLinkEl.href = item.value;

        listItemLinkEl.addEventListener("pointerdown", (e) => {
          e.preventDefault();
          document.location.href = item.value;
        });

        listItemEl.appendChild(listItemLinkEl);
        listEl.appendChild(listItemEl);
      }

      targetEl.appendChild(listEl);
    }

    function renderResults(autocompleteMenuEl: HTMLElement, inst: Autocomplete) {
      autocompleteMenuEl.innerHTML = ""; // clear space

      // @ts-ignore
      const groupedItems = Object.groupBy(inst._items, ({ group }) => group);

      const contentEl = document.createElement("div");
      contentEl.classList.add("autocomplete-menu__content");

      if ("Searches" in groupedItems && "Categories" in groupedItems) {
        const leftEl = document.createElement("div");
        leftEl.classList.add("autocomplete-menu__content--left");

        appendSearches(groupedItems, leftEl);
        contentEl.appendChild(leftEl);

        const rightEl = document.createElement("div");
        rightEl.classList.add("autocomplete-menu__content--right");

        appendCategories(groupedItems, rightEl);
        contentEl.appendChild(rightEl);
      }
      else if ("Searches" in groupedItems) {
        const fullEl = document.createElement("div");
        fullEl.classList.add("autocomplete-menu__content--full");

        appendSearches(groupedItems, fullEl);
        contentEl.appendChild(fullEl);
      }
      else if ("Categories" in groupedItems) {
        const fullEl = document.createElement("div");
        fullEl.classList.add("autocomplete-menu__content--full");

        appendCategories(groupedItems, fullEl)
        contentEl.appendChild(fullEl);
      }

      autocompleteMenuEl.appendChild(contentEl);
    }

    async function afterFetch(inst: Autocomplete) {
      const autocompleteMenuElDesktop = document.getElementById("ac-menu-1") as HTMLElement;
      const autocompleteMenuElMobile = document.getElementById("ac-menu-2") as HTMLElement;

      if (autocompleteMenuElDesktop && !isHiddenMenuEl(autocompleteMenuElDesktop)) {
        renderResults(autocompleteMenuElDesktop, inst);
      }

      if (autocompleteMenuElMobile && !isHiddenMenuEl(autocompleteMenuElMobile)) {
        renderResults(autocompleteMenuElMobile, inst);
      }
    }

    async function process(response: Response, _: Autocomplete): Promise<any> {
      const json = await response.json();

      totalSuggestionCount = json.totalSuggestionCount;

      let activeElCounter = 0;

      const textSuggestions = json.textSuggestions.map((suggestion: any) => {
        activeElCounter = activeElCounter + 1;

        return {
          label: suggestion.text,
          value: suggestion.detailUri,
          counter: activeElCounter,
        };
      });

      const categorySuggestions = json.categorySuggestions.map((suggestion: any) => {
        activeElCounter = activeElCounter + 1;

        return {
          label: suggestion.text,
          value: suggestion.detailUri,
          imageUri: suggestion.imageUri,
          counter: activeElCounter,
        };
      });

      const result: Array<{ group: string; items: Array<{ label:string; value: string; imageUri?: string | null }> }> = [];

      if (textSuggestions.length > 0) {
        result.push({
          group: "Searches",
          items: textSuggestions,
        });
      }

      if (categorySuggestions.length > 0) {
        result.push({
          group: "Categories",
          items: categorySuggestions,
        });
      }

      return result;
    }

    function render(item: any, label: string, _: Autocomplete) {
      return !item.imageUri
        ? `<span class="auto-complete__text">${label}</span>`
        : `<span class="auto-complete__category"><img src="${item.imageUri}" alt=""> ${label}</span>`;
    }

    function select(item: { label: string; value: string }, _: Autocomplete) {
      document.location.href = item.value;
    }

    const config: Partial<Config> = {
      autoselectFirst: false,
      debounceTime: 500,
      fixed: true,
      fullWidth: true,
      highlightTyped: true,
      liveServer: true,
      maximumItems: 10,
      preventBrowserAutocomplete: true,
      queryParam: "searchTerm",
      onAfterFetch: afterFetch,
      // onRenderItem: render, // not used (custom design after fetch)
      onServerResponse: process,
      // onSelectItem: select, // not used (common anchor tags in custom design)
      server: `/api/search-suggestions`,
      showAllSuggestions: true,
      suggestionsThreshold: 3,
    };

    new Autocomplete(inputElement, config);

    inputElement.addEventListener("keydown", e => {
      if (e.key === "Enter") {
        e.preventDefault();

        const activeMenuEl = getActiveMenuEl();
        const activeListItemEl = getActiveListItemEl(activeMenuEl);

        if (activeListItemEl) {
          document.location.href = $(activeListItemEl).find("a").prop("href");
        }
        else {
          const actionUrl = $(inputElement).closest("form").prop("action");
          document.location.href = `${actionUrl}?searchTerm=${inputElement.value}`;
        }
      }
      else if (e.key === "Tab") {
        toggleActiveListItemEl(true, e);
      }
      else if (e.key === "ArrowDown") {
        toggleActiveListItemEl(true, e);
      }
      else if (e.key === "ArrowUp") {
        toggleActiveListItemEl(false, e);
      }
    });
  }
}

$$("#search-auto-complete--desktop", (el) => new SearchAutoComplete(el as HTMLInputElement));
$$("#search-auto-complete--mobile", (el) => new SearchAutoComplete(el as HTMLInputElement));
